import { FC, ReactNode } from 'react';
import { AText } from '../AText';
import { Box } from '../Box';

import styles from './index.module.css';

interface TooltipProps {
  className?: string;
  children?: ReactNode;
}

export const Tooltip: FC<TooltipProps> = ({ children, className = '' }) => (
  <Box padding="xs s" className={`${styles.inputTooltip} ${className}`}>
    {children && (
      <AText breed="R" size="s" color="txt_color_4">
        {children}
      </AText>
    )}
  </Box>
);
